import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from '../../../core/navigation/navigation.service';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { VexConfigService } from '@vex/config/vex-config.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { NavigationItem } from '../../../core/navigation/navigation-item.interface';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { Observable, of } from 'rxjs';
import { SidenavUserMenuComponent } from './sidenav-user-menu/sidenav-user-menu.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { SidenavItemComponent } from './sidenav-item/sidenav-item.component';
import { VexScrollbarComponent } from '@vex/components/vex-scrollbar/vex-scrollbar.component';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { Helper } from '../../../shared/constants/helper';
import { RolePermissionService } from '../../../shared/services/role-permission.service';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
  selector: 'vex-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
    VexScrollbarComponent,
    NgFor,
    SidenavItemComponent,
    AsyncPipe
  ],
  providers: [AuthService, RolePermissionService]
})
export class SidenavComponent implements OnInit {
  @Input() collapsed: boolean = false;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  title$ = this.configService.config$.pipe(
    map((config) => config.sidenav.title)
  );
  imageUrl$ = this.configService.config$.pipe(
    map((config) => config.sidenav.imageUrl)
  );
  showCollapsePin$ = this.configService.config$.pipe(
    map((config) => config.sidenav.showCollapsePin)
  );
  userVisible$ = this.configService.config$.pipe(
    map((config) => config.sidenav.user.visible)
  );
  searchVisible$ = this.configService.config$.pipe(
    map((config) => config.sidenav.search.visible)
  );

  userMenuOpen$: Observable<boolean> = of(false);
  items$;
  // items$: Observable<NavigationItem[]> = this.navigationService.items$;
  user: any;
  rolePermissions: any;

  constructor(
    private navigationService: NavigationService,
    private layoutService: VexLayoutService,
    private configService: VexConfigService,
    private readonly popoverService: VexPopoverService,
    private router: Router,
    private readonly dialog: MatDialog,
    private rolePermissionService: RolePermissionService,
    private authService: AuthService
  ) {
    const self = JSON.parse(localStorage.getItem('self'));
    if (self && self?.user_type == 'EMPLOYEE') {
      this.authService.self().subscribe((data) => {
        if (data && data.id) {
          this.user = data;
          if (this.user && this.user['user_type'] === 'EMPLOYEE') {
            this.checkUserDetails();
          } else {
          }
        }
      });
    } else {
      this.items$ = this.navigationService.items$;
    }
  }

  ngOnInit() {}

  collapseOpenSidenav() {
    this.layoutService.collapseOpenSidenav();
  }

  collapseCloseSidenav() {
    this.layoutService.collapseCloseSidenav();
  }

  toggleCollapse() {
    this.collapsed
      ? this.layoutService.expandSidenav()
      : this.layoutService.collapseSidenav();
  }

  trackByRoute(index: number, item: NavigationItem): string {
    if (item.type === 'link') {
      return item.route;
    }

    return item.label;
  }

  openProfileMenu(origin: HTMLDivElement): void {
    this.userMenuOpen$ = of(
      this.popoverService.open({
        content: SidenavUserMenuComponent,
        origin,
        offsetY: -8,
        width: origin.clientWidth,
        position: [
          {
            originX: 'center',
            originY: 'top',
            overlayX: 'center',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap((popoverRef) => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true)
    );
  }

  openSearch(): void {
    this.dialog.open(SearchModalComponent, {
      panelClass: 'vex-dialog-glossy',
      width: '100%',
      maxWidth: '600px'
    });
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }

  checkUserDetails() {
    this.rolePermissionService
      .get({ role_id: this.user?.role_id })
      .subscribe((data) => {
        if (data && data['data'].length > 0) {
          this.rolePermissions = data['data'];
          let rolePermissions = [];
          if (this.rolePermissions && this.rolePermissions.length > 0) {
            this.rolePermissions.forEach((subPermission) => {
              if (subPermission && subPermission['sub_permission']) {
                const subPermMeta = subPermission['sub_permission']['meta'];
                if (subPermMeta) {
                  rolePermissions.push(subPermMeta);
                }
              }
            });
          }

          // @ts-ignore
          this.navigationService.items$.forEach((menu) => {
            menu.forEach((item) => {
              if (
                item &&
                item['availableTo'] &&
                !item['availableTo'].includes('ALL')
              ) {
                item['is_hidden'] = !Helper.findCommonElements(
                  item['availableTo'],
                  rolePermissions
                );
                if (item['children'] && item['children'].length > 0) {
                  item['children'].forEach((child) => {
                    child['is_hidden'] = !Helper.findCommonElements(
                      child.availableTo,
                      rolePermissions
                    );
                  });
                }
              } else {
                item['is_hidden'] = false;
              }
            });
          });

          this.items$ = this.navigationService.items$;
        }
      });
  }
}
